import React, { useReducer, useContext, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Tooltip from "../components/common/ToolTip";
import { getAuthToken } from "../api/api";
import {
  getAPIUrl,
  ValidateInputField,
  notify,
} from "../components/common/helpers";
import { getUserDetails } from "../components/sidebar/Sidenav";
import "../styles/Modal.css";
import {ReleaseContext} from "../pages/ReleaseManagement.js";
import { ReactComponent as Close } from "../../src/icons-svg/icons/close.svg";

const initialState = {
  formData: {
    reject_reason: "",
  },
  formErrors: {
    reject_reason: "",
  },
  validated: false,
  error: "",
};

const formReducer = (state, action) => {
  switch (action.type) {
    case "SET_FIELD_VALUE":
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.field]: action.value,
        },
      };
      case "SET_FORM_ERRORS":
      return {
        ...state,
        formErrors: {
          ...state.formErrors,
          [action.field]: action.error,
        },
      };
    case "RESET_FORM":
      return initialState;
    default:
      return state;
  }
};

const RejectionSelectionModal = (props) => {
  const AuthToken = getAuthToken();
  const [state, dispatch] = useReducer(formReducer, initialState);
  const controller = new AbortController();

  const isFormValid = () => {
    return (
      Object.values(formErrors).every((error) => error === "valid") &&
      formData.reject_reason
    );
  };

  const {
    validated,
    formData,
    formErrors
  } = state;

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  const handleClose = () => {
    dispatch({ type: "RESET_FORM" });
    setIsRejected(false)
  };

  const { isRejected, setIsRejected, gridEntries, getRelease } = useContext(ReleaseContext);


  //Add a function to handle changes to the email input
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const error = ValidateInputField(name, value);
    dispatch({ type: "SET_FIELD_VALUE", field: name, value });
    dispatch({ type: "SET_FORM_ERRORS", field: name, error });
  };

  const formatFormData = (data) => {
    return data.charAt(0).toUpperCase() + data.slice(1);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const release_details_id = gridEntries.release_details_id;
    const body = {
          release_details_id,
          approval_state: "rejected",
          updated_by: getUserDetails().username,
        };
    const formData = new FormData(event.target);
    Object.entries(body).forEach(([key, value]) => {
      formData.append(key, value);
    });
    const formDataObj = Object.fromEntries(formData.entries());
    formDataObj.reject_reason = formatFormData(formDataObj.reject_reason);
    axios({
      method: "POST",
      url: getAPIUrl("approveAndRejectApi"),
      headers: { Authorization: AuthToken },
      signal: controller.signal,
      data: formDataObj,
    })
      .then((res) => {
        if (res) {
          handleClose();
          getRelease();
        }
      })
      .catch((error) => {
        error.message !== "canceled" && notify("submission");
      });
    dispatch({ type: "SET_VALIDATED", validated: false });
  };

  return (
      <Modal
        show={isRejected}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
            <Col sm={{ span: 7 }}>
             Enter a Reason
             </Col>
             <Col sm={{ offset: 3 }}>
                <Button
                    className="col-md-8 hoverEffect"
                    size="sm" 
                    variant="Dark"
                    onClick={handleClose}
                  >
                    <Close/>
                  </Button>
                  </Col>
             </Row>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row  className="mb-3">
              <Col sm={{ span: 2 }}>
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  //size="sm"
                  //column
                  //sm={3}
                  htmlFor="reason"
                >
                  Reason
                </Form.Label>
                </Col>
                <Col sm={{ span: 8 }}>
                  <Form.Control
                    size="sm"
                    required
                    as="textarea"
                    maxLength={500}
                    placeholder="Reason Description"
                    id="validationCustom03"
                    name="reject_reason"
                    onChange={handleInputChange}
                    isInvalid={formErrors.reject_reason === "error"}
                    isValid={formErrors.reject_reason === "valid"}
                  />
                  {formErrors.reject_reason === "error" && (
                    <Tooltip type="rejection_reason" charLength={4} required={true}/>
                  )}
                </Col>
            </Row>

          <Row>
            <Col sm={{ span: 9, offset: 2 }}>
              <Button
                className="col-md-5"
                size="sm"
                variant="secondary"
                type="submit"
                disabled={!isFormValid()}
              >
                Submit
              </Button>{" "}
              <Button
                className="col-md-5"
                size="sm"
                variant="secondary"
                onClick={handleClose}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
        </Modal.Body>
      </Modal>
  );
};

export default RejectionSelectionModal;
